import type { FC } from 'react';
import { Button } from '@/components/raven/ui/Button';
import styles from '@/components/raven/Poll/styles.module.css';
import ArrowRight from '@themaven-net/raven-assets/ArrowRight';

export const PollFooter: FC<{
	hasVoted: boolean;
	isClosed: boolean;
	selectedOption: null | string;
	voteCount: number;
}> = ({ hasVoted, isClosed, selectedOption, voteCount }) => {
	return (
		<div className={styles.pollFooter}>
			<div className={styles.pollVoteCount}>
				<span>
					{voteCount} {isClosed && 'total '}
					{voteCount === 1 ? 'vote' : 'votes'}
				</span>
			</div>
			{/* TODO: Add dynamic comment count with popout
			<div className={styles.pollComments}>
				<Comment /> 6 <span className={styles.commentsText}>Comments</span>
			</div> */}
			{!isClosed && !hasVoted ? (
				<Button
					className={styles.pollVoteButton}
					disabled={selectedOption === null}
					onClick={() => {}}
					type="submit"
					variation="link"
				>
					Cast Your Vote
					<ArrowRight />
				</Button>
			) : null}
			{/* TODO: Add link to discussion or results
			<Button
				className={styles.pollVoteButton}
				onClick={() => {}} // TODO: Link to discussion or results
				type="button"
				variation="link"
			>
				View Discussion
				<ArrowRight />
			</Button> */}
		</div>
	);
};
